import { SpecialistTagsDirections } from "../types/TypeSpecialist";

export const directions: { [key: string]: SpecialistTagsDirections } = {
  Coach: SpecialistTagsDirections.COACHING,
  Psychotherapist: SpecialistTagsDirections.PSYCHOTHERAPY,
  Mentor: SpecialistTagsDirections.MENTOR,
  Psychologist: SpecialistTagsDirections.PSYCHOLOGY,
  Psychiatrist: SpecialistTagsDirections.PSYCHIATRY,
  Lawyer: SpecialistTagsDirections.LAWYER,
  Nutritionist: SpecialistTagsDirections.NUTRITIONIST,
  Dietitian: SpecialistTagsDirections.DIETITIAN,
  Mediator: SpecialistTagsDirections.MEDIATOR,
  Consultant: SpecialistTagsDirections.CONSULTING,
};
